import React, { useState } from "react";
import Label from "../Common/Label";
import Toast from "../../utils/Toast";
import DeleteIcon from "../../assets/images/deleteIcon.svg";
import { DollarSign } from "lucide-react";

interface ChannelCardProps {
  duration: string;
  price: string;
  jobType: string;
  jobTitle: string;
  websiteLink: string;
  calendarIcon: string;
  logo?: string;
  productId: string;
  isSelected?: boolean;
  dollarIcon: string;
  linkIcon: string;
  onMoreInfo?: () => void;
  onAddCampaign?: () => boolean | void;
  onRemoveCampaign?: () => boolean | void;
}

const ChannelCard: React.FC<ChannelCardProps> = ({
  duration,
  price,
  jobType,
  jobTitle,
  websiteLink,
  calendarIcon,
  dollarIcon,
  linkIcon,
  logo,
  productId,
  isSelected = false,
  onMoreInfo,
  onAddCampaign,
  onRemoveCampaign,
}) => {
  const [logoError, setLogoError] = useState(false);
  const fallbackLetter = (jobTitle || jobType || "?").charAt(0).toUpperCase();

  const handleToggleCampaign = () => {
    const action = isSelected ? onRemoveCampaign : onAddCampaign;
    const message = isSelected
      ? "Campaign Removed Successfully"
      : "Campaign Added Successfully";

    const result = action?.();
    if (result !== false) {
      Toast(message);
    }
  };

  const handleLogoError = () => {
    setLogoError(true);
  };

  return (
    <div className="col-12 col-md-6">
      <div className="p-2 h-100 channel-card">
        <div
          className="image-section"
          style={{
            width: "100%",
            height: "120px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px 8px 0 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "16px",
            // border: "1px solid #e9ecef",
            borderBottom: "none",
            overflow: "hidden",
          }}
        >
          {logo && !logoError ? (
            <img
              src={logo}
              alt={`${jobTitle} logo`}
              className="channel-card-logo"
              onError={handleLogoError}
              style={{
                maxWidth: "90%",
                maxHeight: "90%",
                width: "auto",
                height: "auto",
                objectFit: "contain",
              }}
            />
          ) : (
            <div
              className="channel-card-logo-fallback"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#6c757d",
                fontWeight: "bold",
                fontSize: "24px",
                textTransform: "uppercase",
              }}
            >
              {fallbackLetter}
            </div>
          )}
        </div>

        <div className="description-section mt-2">
          <div className="date-money d-flex align-items-center justify-content-between">
            <div className="date d-flex align-items-center gap-1 justify-content-start">
              <img src={calendarIcon} alt="calendarIcon" />
              <Label
                children={duration}
                fontWeight={500}
                fontSize={"16px"}
                color="#13213B"
              />
            </div>
            <div className="money d-flex align-items-center  justify-content-start gap-0">
              {/* <img src={dollarIcon} alt="dollarIcon" /> */}
              <DollarSign size={16} color="#13213B" />
              <Label
                children={price}
                fontWeight={500}
                fontSize={"16px"}
                color="#13213B"
              />
            </div>
          </div>

          <div className="information mt-2">
            <div className="desc">
              <Label
                children={jobType}
                fontWeight={500}
                fontSize={"12px"}
                color="#8C8C8C"
              />
              <Label
                children={jobTitle}
                fontWeight={500}
                fontSize={"16px"}
                color="#13213B"
              />
            </div>
            <div
              className="link d-flex align-items-center justify-content-start gap-1 mt-2 cursor-pointer"
              onClick={() => window.open(websiteLink, "_blank")}
            >
              <img src={linkIcon} alt="LinkIcon" />
              <Label
                children={websiteLink}
                fontWeight={500}
                fontSize={"16px"}
                color="#13213B"
                className="cursor-pointer"
              />
            </div>
          </div>

          <div className="buttons mt-2">
            {!isSelected ? (
              <div
                className="add-campaign cursor-pointer"
                onClick={handleToggleCampaign}
                style={{ color: "#FFF", fontWeight: 600 }}
              >
                Add Campaign
              </div>
            ) : (
              <div
                className="remove-campaign cursor-pointer"
                onClick={handleToggleCampaign}
                style={{ color: "red", fontWeight: 600 }}
              >
                <img
                  src={DeleteIcon}
                  alt="delete-icon"
                  style={{ height: "20px", width: "20px" }}
                />
                Remove Campaign
              </div>
            )}

            <div
              className="more-info mt-2 d-flex align-items-center justify-content-center pt-2 pb-2"
              onClick={onMoreInfo}
            >
              <Label
                children="More Information"
                fontWeight={500}
                fontSize={"12px"}
                color="#13213B"
                className="cursor-pointer"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChannelCard;
